export default {"src":"/_next/static/media/19-icon.bef12726.svg","height":46,"width":34,"blurWidth":0,"blurHeight":0};